<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import { initLang } from '@/utils/init'
import { startProbeAndPush } from './utils/ip'

export default {
  onLaunch: function (query) {
    initLang(query.query.language)
    startProbeAndPush()
  },
  onShow: function () {
    this.$store.commit('login')
    console.log('App Show')
  },
  onHide: function () {
    console.log('App Hide')
  }
}
</script>

<style lang="scss">
@import 'uview-ui/index.scss';
@import "./index";

//默认灰色
page {
  width: 750rpx;
  overflow-x: hidden;
}

// 白色背景
.page {
  background-color: #FFF;
  width: 750rpx;
  overflow-x: hidden;
  min-height: 100vh;
}

.body {
  height: 100vh;
  // background-color: rgba(0, 0, 0, .5);
}

.u-line-1 {
  color: #fff !important;
}

.u-column-item .u-line-1 {
  color: #000 !important;
}


.rule-box, .dialog {
  .u-mode-center-box {
    background-color: transparent !important;
  }
}

.score-icon {
  display: flex;
  line-height: 26rpx;
  gap: 2rpx;

  &:after {
    width: 26rpx;
    height: 26rpx;
    content: '';
    background: url("./static/activities/weekStar/score.png") top center / 100% no-repeat;
  }
}

.gift-icon {
  display: flex;
  align-items: center;
  line-height: 34rpx;
  gap: 2rpx;

  &:after {
    width: 34rpx;
    height: 34rpx;
    content: '';
    background: url("./static/activities/gift.png") top center / 100% no-repeat;
  }
}

.gift-icon-2 {
  .gift-icon {
    &:after {
      background: url("./static/activities/gift_2.png") top center / 100% no-repeat;
    }
  }
}

.gift-icon-3 {
  .gift-icon {
    &:after {
      background: url("https://img.trelokibu.com/OichatCS/h5/1753156519278.png") top center / 100% no-repeat;
    }
  }
}

.dollar-icon {
  display: flex;
  line-height: 34rpx;
  gap: 2rpx;

  &:after {
    width: 34rpx;
    height: 34rpx;
    content: '';
    background: url("./static/dollar.png") top center / 100% no-repeat;
  }
}

.time-icon {
  &:before {
    content: '';
    width: 24rpx;
    height: 24rpx;
    margin-right: 10rpx;
    background: url("./static/activities/time.png") center / 100% no-repeat;
  }
}

.special-id {
  font-weight: 700;
  background: linear-gradient(to right, #FFBB00, #FF0073);
  -webkit-background-clip: text;
  color: transparent !important;
}

.id-gap {
  margin: 0 2rpx;
}

.gold-icon2 .gift-gold {
  background-image: url("./static/activities/gift_gold2.png") !important;
}

.gold-icon3 .gift-gold {
  background-image: url("./static/activities/gift_gold3.png") !important;
}

.gold-icon4 .gift-gold {
  background-image: url("https://img.trelokibu.com/OichatCS/h5/1748341735341.png") !important;
}
</style>